export class SOPS {
	fileUid: string;

	fileName: string;

	versionControlVersion: number;

	fileTime: Date;

	importTime: Date;

	originTypeUid: number; // 205 Perforce, 206 UserUpload

	regBy: string;

	regTime: Date;

	vinNo: string;

	vehicleName: string;

	fpcs: FPC[];

	xpcs: XPC[];

	functionParameters: FunctionParameter[];
}

export class FPC {
	name: string; // example 1

	value: string; // example A

	familyDescription: string; // example Product class

	variantDescription: string; // example Truck
}

export class XPC {
	name: string; // examples: ChassisNo, ASSY_COO, FPC1122

	value: string;
}

export class FunctionParameter {
	family: string; //example COO

	parentName: string; //example COO7

	name: string; //example ServiceDistVeh

	value: string;
}
